import * as React from "react"
import { ComparisonController, DateRangePicker } from "./components"

export default ({ comparisonDisabled }) => (
  <div>
    <DateRangePicker />
    <ComparisonController comparisonDisabled={comparisonDisabled} />
  </div>
)
